module.exports = __webpack_public_path__ + "static/pizza_2-083c4ae0682f6e0c7fdbb1076ef36716.jpg";